var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-tags"},[_c('div',{staticClass:"more-clue"}),_vm._v(" "),_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.tagList),function(tag){return _c('comp-tag-tab-item',{key:tag.jobCode,attrs:{"tag":tag.jobName},on:{"clickTagItem":function($event){return _vm.clickTagList(tag)}}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238be0fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompTagTabList.vue
// module id = null
// module chunks = 